import { Button } from "@/components/ui/button";
import { X, Trash2, FileText } from "lucide-react";

export default function HistorySidebar({ isOpen, onClose, history, onLoad, onDelete }) {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const truncateText = (text, maxLength = 100) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 z-40"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', backdropFilter: 'blur(4px)' }}
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <div
        className="fixed z-50 h-full w-80 flex-shrink-0 flex flex-col transition-transform duration-300 ease-out"
        style={{ 
          backgroundColor: '#1a2332',
          borderRight: '1px solid #2d3748',
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)'
        }}
        data-testid="history-sidebar"
      >
        {/* Header */}
        <div 
          className="h-16 flex items-center justify-between px-4"
          style={{ borderBottom: '1px solid #2d3748' }}
        >
          <h2 
            className="font-semibold text-lg"
            style={{ fontFamily: 'Manrope, sans-serif', color: '#f5f5f5' }}
          >
            History
          </h2>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            data-testid="close-history-btn"
            style={{ color: '#a0aec0' }}
          >
            <X className="h-5 w-5" />
          </Button>
        </div>

        {/* History List */}
        <div className="flex-1 overflow-y-auto p-4 space-y-3">
          {history.length === 0 ? (
            <div className="text-center py-12">
              <FileText className="h-12 w-12 mx-auto mb-4" style={{ color: '#4a5568' }} />
              <p style={{ color: '#a0aec0' }} className="text-sm">No saved transcriptions</p>
              <p style={{ color: '#718096' }} className="text-xs mt-1">
                Your saved recordings will appear here
              </p>
            </div>
          ) : (
            history.map((item) => (
              <div
                key={item.id}
                className="group rounded-xl overflow-hidden transition-all duration-200"
                style={{ 
                  backgroundColor: '#0f1419',
                  border: '1px solid #2d3748'
                }}
                data-testid={`history-item-${item.id}`}
              >
                <button
                  onClick={() => onLoad(item)}
                  className="w-full text-left p-4"
                  data-testid={`load-history-${item.id}`}
                >
                  <p 
                    className="font-medium text-sm mb-1 truncate"
                    style={{ color: '#f5f5f5' }}
                  >
                    {item.title || "Recording"}
                  </p>
                  <p className="text-xs mb-2" style={{ color: '#718096' }}>
                    {formatDate(item.timestamp)}
                  </p>
                  <p 
                    className="text-sm leading-relaxed"
                    style={{ color: '#a0aec0' }}
                  >
                    {truncateText(item.text)}
                  </p>
                </button>
                <div className="px-4 pb-3 flex justify-end">
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete(item.id);
                    }}
                    data-testid={`delete-history-${item.id}`}
                    className="h-8 px-3 transition-all"
                    style={{ color: '#a0aec0' }}
                  >
                    <Trash2 className="h-4 w-4 mr-1" />
                    <span className="text-xs">Delete</span>
                  </Button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
}
